import { commonSbEnv } from "./env.sb.common";

const env: Partial<typeof commonSbEnv> = {
  production: true,
  page: 'bursa-nivel-3',
  pageCode: 'sbbn3',
  meta: {
    siteTitle: 'Stiinta Banilor - curs de investitii eficiente pe bursa pentru dividende',
    ogSiteName: 'Stiinta Banilor',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa-pentru-dividende/',
    ogImage: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa-pentru-dividende/assets/images/bursa-nivel-3/cover-fb.png'
  }
};

export const environment = { ...commonSbEnv, ...env };
